import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const ListIcon: FC<IconProps> = ({
  color = theme.palette.text.primary,
  size = IconSize.medium,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.75 4.25C2.33579 4.25 2 4.58579 2 5C2 5.41421 2.33579 5.75 2.75 5.75H4.25C4.66421 5.75 5 5.41421 5 5C5 4.58579 4.66421 4.25 4.25 4.25H2.75Z"
          fill={color}
        />
        <path
          d="M7.5 4.25C7.08579 4.25 6.75 4.58579 6.75 5C6.75 5.41421 7.08579 5.75 7.5 5.75H17.25C17.6642 5.75 18 5.41421 18 5C18 4.58579 17.6642 4.25 17.25 4.25H7.5Z"
          fill={color}
        />
        <path
          d="M2 10C2 9.58579 2.33579 9.25 2.75 9.25H4.25C4.66421 9.25 5 9.58579 5 10C5 10.4142 4.66421 10.75 4.25 10.75H2.75C2.33579 10.75 2 10.4142 2 10Z"
          fill={color}
        />
        <path
          d="M7.5 9.25C7.08579 9.25 6.75 9.58579 6.75 10C6.75 10.4142 7.08579 10.75 7.5 10.75H17.25C17.6642 10.75 18 10.4142 18 10C18 9.58579 17.6642 9.25 17.25 9.25H7.5Z"
          fill={color}
        />
        <path
          d="M2 15C2 14.5858 2.33579 14.25 2.75 14.25H4.25C4.66421 14.25 5 14.5858 5 15C5 15.4142 4.66421 15.75 4.25 15.75H2.75C2.33579 15.75 2 15.4142 2 15Z"
          fill={color}
        />
        <path
          d="M7.5 14.25C7.08579 14.25 6.75 14.5858 6.75 15C6.75 15.4142 7.08579 15.75 7.5 15.75H17.25C17.6642 15.75 18 15.4142 18 15C18 14.5858 17.6642 14.25 17.25 14.25H7.5Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
